/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Funnel_Card_CheckoutInputs */

const en_admin_funnel_card_checkout = /** @type {(inputs: Admin_Funnel_Card_CheckoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sent to payment today`)
};

/**
* | output |
* | --- |
* | "Sent to payment today" |
*
* @param {Admin_Funnel_Card_CheckoutInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_funnel_card_checkout = /** @type {((inputs?: Admin_Funnel_Card_CheckoutInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Funnel_Card_CheckoutInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_funnel_card_checkout(inputs)
});
export { admin_funnel_card_checkout as "admin.funnel.card.checkout" }